import { Link } from "react-router-dom";
import './Footer.css'
function Footer({title,link,toAdress}) {
    return (
        <div className='footer-link'>
            {title}
            <Link to={toAdress} className='footer-link-element'>
                {link}
            </Link>
        </div>
    )
}

export default Footer
